import { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ChatBoxType2 from "../chat/chatType2";
import Header from "../header/header";
import { useGame } from "../header/GameContext";
import "./answer.css";

export default function Answer(props) {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { increaseMissionOnce } = useGame();

  const [buttonData, setButtonData] = useState(null);

  const {
    DateVal: propDateVal,
    titImgclassName: propTitImgclassName,
    counting: propCounting = false,
    missionKey: propMissionKey,
  } = props;

  const DateVal = state?.DateValState ?? propDateVal;
  const titImgclassName = state?.titImgclassNameState ?? propTitImgclassName;
  const counting = state?.countingState ?? propCounting;
  const missionKey = state?.missionKeyState ?? propMissionKey;

  const chatRef = useRef(null);

  useEffect(() => {
    if (!counting || !missionKey) return;
    increaseMissionOnce(missionKey);
  }, [counting, missionKey, increaseMissionOnce]);

  /* =========================
     버튼 노출 시 window 스크롤
  ========================= */
  useEffect(() => {
    if (!buttonData) return;
    setTimeout(() => {
      window.scrollTo(0, document.body.scrollHeight);
    }, 0);
  }, [buttonData]);

  const handleButtonClick = () => {
    setButtonData(null);

    const isLastProblem = missionKey === "q16";
    if (isLastProblem) {
      navigate("/clear");
    } else {
      navigate("/keywordInput", {
        state: {
          answerDataState: "keyword",
          DateValState: "DATA3",
          titImgclassNameState: "infoTit",
          hintWhetherIsState: false,
          hintContentState: "",
        },
      });
    }
  };

  return (
    <div id="content">
      <Header />

      <div className="content_box1 ans0001">
        <div className="box box_con con_box1 con_pd5 con_box_c">
          <div className="mission_tit answerTit"></div>

          <ChatBoxType2
            DateVal={DateVal}
            titImgclassName={titImgclassName}
            chatClass="chat_box6"
            onButton={setButtonData}
            ref={chatRef}
          />
        </div>

        {/* ✅ 기존 구조 그대로 버튼은 외부 */}
        {buttonData && (
          <div id="box_ft">
            <input
              type="button"
              className="inputBtn02 btnCode go_url_btn"
              value={buttonData.label}
              onClick={handleButtonClick}
            />
          </div>
        )}
      </div>
    </div>
  );
}
